import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import BillingPeriod from "../../../entities/BillingPeriod";
import {BillingPeriodService} from "../../../service/BillingPeriodService";
import Agency from "../../../entities/Agency";
import { AgencyService } from "../../../service/AgencyService";

class NewBillingPeriodStore {

    public billingPeriodId?: string;
    public billingPeriod: BillingPeriod;
    public isEditing: boolean;
    public isModalOpen: boolean;
    public loading: boolean;

    public agencies: Agency[];

    public commonStore: CommonStore;
    public agencyId?: string;


    constructor(commonStore: CommonStore, billingPeriodId?: string, agencyId?: string) {
        this.isEditing = !!billingPeriodId;
        this.billingPeriodId = billingPeriodId;
        this.isModalOpen = false;
        this.billingPeriod = {} as BillingPeriod;
        this.loading = false;
        this.commonStore = commonStore;
        this.agencyId = agencyId;
        this.agencies = [];
        makeAutoObservable(this);
    }

    @action
    public async loadBillingPeriod() {
        if (this.billingPeriodId) {
            this.isEditing = true;
            const response = await BillingPeriodService.find(this.billingPeriodId!)
            if (response.success && response.data) {
                this.billingPeriod = response.data;
            }
            this.commonStore.processErrors(response);
        }
    }

    @action
    public async loadAgencies() {
        const response = await AgencyService.get(1, 1000);
        if (response.success && response.data) {
            this.agencies = response.data.data;
        }
    }

    @action
    public async openModal() {
        this.loading = true;
        await this.loadBillingPeriod();
        this.isModalOpen = true;
        this.loading = false;
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
        this.billingPeriod = {} as BillingPeriod;
    }

    @action
    public async save(): Promise<boolean> {
        this.loading = true;
        const serviceToCall = this.isEditing ? BillingPeriodService.update : BillingPeriodService.create;
        const response = await serviceToCall(this.billingPeriod);
        this.commonStore.processErrors(response);
        this.processError(response.error);
        this.loading = false;
        return response.success;
    }

    processError(error?: string) {
    }
}

export default NewBillingPeriodStore;